import cn from 'classnames'

const TextBoxReset = (
  {
    value,
    onClick,
    onChange,
    label,
    error,
    showValidationErrors,
    disabled,
    field,
  },
  props
) => {
  return (
    <div className="textbox-reset">
      <input
        {...props}
        {...field}
        onChange={onChange}
        value={value}
        disabled={disabled}
        className={cn('textbox-reset__input', {
          '-error': error && showValidationErrors,
        })}
        type="number"
        placeholder="#"
      />
      <label
        className={cn('textbox-reset__label', {
          '-error': error && showValidationErrors,
        })}
      >
        {label}
      </label>
      <button
        onClick={onClick}
        className="textbox-reset__button"
        type="button"
        disabled={disabled}
      >
        Reset
      </button>
    </div>
  )
}

export default TextBoxReset
